import { action } from 'mobx';

export interface IFormatStore {
	formatInterval(interval: number): string;
	formatChartInterval(interval: number): string;
	formatIntervals(intervals: number[]): string; 
	formatChange(change: number): string;
	formatTimeAgo(timestamp: Date): string;
	formatTime(timestamp: Date): string;
	formatNumber(num: number, decimals: number): string;
}

class FormatStore implements IFormatStore {

	private intervalsShort: string[] = ['flash', '1m', '5m', '15m', '1h', '4h', '24h'];
	private intervalsChart: string[] = ['1', '1', '5', '15', '60', '240', 'D'];

	@action.bound formatInterval(interval: number): string {
		return this.intervalsShort[interval];
	}

	@action.bound formatChartInterval(interval: number): string {
		return this.intervalsChart[interval];
	}

	@action.bound formatIntervals(intervals: number[]): string {
		return intervals.sort().map(i => this.intervalsShort[i]).join(', ');
	}

	@action.bound formatChange(change: number): string {
		return change > 0 ? '+' + this.roundToTwo(change) :  '' + this.roundToTwo(change);
	}  

	@action formatTimeAgo(timestamp: Date): string {
		var currentTimestamp = new Date().getTime();
		var diff = currentTimestamp - new Date(timestamp).getTime();

		var diffHours = Math.round(diff / 3600000);
		if (diffHours >= 1) {
			return diffHours + ' hrs.';
		}

		var diffMinutes = Math.round(diff / 60000);
		return diffMinutes + ' min.';
	}

	@action formatTime(timestamp: Date): string {
		// var hours = timestamp.getUTCHours();
		// var minutes = timestamp.getUTCMinutes();
		// var seconds = timestamp.getUTCSeconds();

		// return hours + ':' + minutes + ':' + seconds;
		return  new Date(timestamp).toLocaleTimeString('en-GB');
	}

	@action.bound formatNumber(num: number, decimals: number): string {
		return this.roundToN(num, decimals).toString().replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');
	}

	private roundToTwo(num: number): number {    
		return Math.round( num * 100 + Number.EPSILON ) / 100;
	}

	private roundToN(num: number, decimals: number): number {    
		var n = Math.pow(10, decimals);
		return Math.round( num * n + Number.EPSILON ) / n;
	}
}

export default new FormatStore();